import { useSelector } from "react-redux";

import messages from "../../../../../../../assets/locale/messages";
import {
  CalendarCheckSmallIcon,
  CardSmallIcon,
  CardSwitchSmallIcon,
  CardTypeSmallIcon,
  DollarArrowSmallIcon,
  LocationSmallIcon
} from "../../../../../../../utils/Icons";
import {
  CURRENCIES_IDS,
  CURRENCIES_SYMBOLS
} from "../../../../../../../utils/Constants";
import { formatDate } from "../../../../../../../utils/Helpers";

const TransactionDetails = () => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      requestDetails: {
        offplatformRequest: { transactions }
      }
    }
  } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification.offPlatformVerificationRequestDetails
  );

  const renderTransactionInfo = (icon, label, value) => (
    <div className="col-12 col-md-6 mb-4">
      <div className="d-flex align-items-center">
        <div className="me-4">{icon}</div>
        <div>
          <span className="d-block mb-1 text-light-grey fsize-13">
            {label}
          </span>
          <span className="d-block mb-0 text-color fsize-15 fweight-600 word-break">
            {value || "__"}
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="transaction-details-section white-bg border-radius-10">
      <h6 className="fsize-16 fweight-600 title-color mb-4">
        {transactions.transactionsInfo}
      </h6>
      <div className="row">
        {renderTransactionInfo(
          <CardSwitchSmallIcon />,
          transactions.id,
          requestDetails?.PaymentIntentId
        )}
        {renderTransactionInfo(
          <CardSmallIcon />,
          transactions.accountName,
          requestDetails?.BillingName
        )}
        {renderTransactionInfo(
          <CardTypeSmallIcon />,
          transactions.paymentMethod,
          requestDetails?.BillingCardType
        )}
        {renderTransactionInfo(
          <DollarArrowSmallIcon />,
          transactions.amount,
          `${requestDetails?.CurrencyId === CURRENCIES_IDS.usd ? CURRENCIES_SYMBOLS.usd : CURRENCIES_SYMBOLS.euro} ${requestDetails?.Amount}`
        )}
        {renderTransactionInfo(
          <CalendarCheckSmallIcon />,
          transactions.date,
          formatDate(requestDetails?.PaymentIntentDate)
        )}
        {renderTransactionInfo(
          <LocationSmallIcon />,
          transactions.country,
          requestDetails?.CountryName
        )}
      </div>
    </div>
  );
};

export default TransactionDetails;
